import type { FunctionComponent } from 'react';

import { InChatClarifyCard } from '~/ui/domain/chat/InChatClarifyCard';

import { type ClarifyOptionsResponseEvent, PRESENT_CLARIFY_OPTIONS_TOOL_ID } from '../../data-contract/chat';
import { useChatComposerCallbacks } from '../chat-composer-contexts';
import type { StructuredRenderer } from './types';

const ClarifyInline: FunctionComponent<{ readonly event: ClarifyOptionsResponseEvent }> = ({ event }) => {
    const { sendMessage } = useChatComposerCallbacks();
    return (
        <div className="flex justify-start">
            <InChatClarifyCard options={event.payload.options} onSelect={sendMessage} />
        </div>
    );
};

export const clarifyOptionsRenderer: StructuredRenderer<ClarifyOptionsResponseEvent> = {
    renderInputOverride: (event) => <ClarifyInline event={event} />,
    toolId: PRESENT_CLARIFY_OPTIONS_TOOL_ID,
};
